import { Component, OnInit } from '@angular/core';

import { UiPlatformMenuItems } from '../../../../ui-platform/src/lib/modules/menu/menu.model';

@Component({
  selector: 'sh-platform-menu',
  templateUrl: './platform-status-marker.component.html',
  styleUrl: './platform-status-marker.component.scss',
  standalone: false
})
export class PlatformStatusMarkerComponent implements OnInit {
  usage = `
            <ui-platform-menu
              [type]="'text'"
              [icon]="'translate'"
              [textSize]="'smaller'"
              [menuItems]="menuItems"
              label="English (US)"
              [chevron]="true"
            >
            </ui-platform-menu>
    `;

  menuItemsSample = `
      menuItems: UiPlatformMenuItems = [
        {label: 'English', selected: true, callback: this.firstItemSelected},
        {label: 'Slovak', selectable: true, suffix: '(Primary)'},
        {label: 'Czech', selectable: true},
        {label: 'German', selectable: true, suffix: '(Default)'},
        {divider: true},
        {label: 'Add new language'},
        {label: 'Make selected language primary', disabled: true},
        {label: 'Auto-translate selected language', disabled: true},
        {label: 'Delete selected language', disabled: true},
      ];
    `;

  import = `
    import {UiPlatformMenuComponent} from 'ui-platform';
  `;

  menuItemDone: UiPlatformMenuItems = [{ labelCode: 'Done' }];

  menuItemInteractionNeededVerified: UiPlatformMenuItems = [
    { labelCode: 'Interaction Needed' },
    { labelCode: 'Verified' }];

  constructor() {}

  ngOnInit(): void {}

  firstItemSelected() {}
}
